import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=353b68c8&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
import style0 from "./Business.vue?vue&type=style&index=0&id=353b68c8&prod&scoped=true&lang=css"
import style1 from "./Business.vue?vue&type=style&index=1&id=353b68c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b68c8",
  null
  
)

export default component.exports